export default __webpack_public_path__ + "769e2e8.png";